import { injectable } from "tsyringe";

@injectable()
export class HttpClient {
  public async get(url: string): Promise<Response> {
    const response = await fetch(url, {
      method: "GET",
      mode: "cors",
    });
    if (!response.ok || response.status !== 200) {
      throw new Error(`HTTP error ${url}! Status: ${response.status}`);
    }
    return response;
  }
}
